var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('filiale-header',{attrs:{"filiale":_vm.logic.filiale}}),(_vm.logic && _vm.logic.filiale)?_c('v-container',{staticStyle:{"max-width":"900px"},attrs:{"fluid":""}},[_c('span',{staticClass:"d-block text-h6"},[_vm._v("Vielen Dank, sie haben erfolgreich eine Reservierung aufgegeben")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }